<template>
  <div id="vue-frame">
    <iframe
      width="560"
      height="315"
      :src="'https://prepclass.com.ng/tutor-side-calculator'"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>
<style scoped>
body {
  margin: 0; /* Reset default margin */
}
iframe {
  display: block; /* iframes are inline by default */
  background: #000;
  border: none; /* Reset default border */
  height: 100vh; /* Viewport-relative units */
  width: 100vw;
}
.modal.show .modal-dialog {
  width: 100vw !important;
  max-width: 100vw;
  margin-top: -20px !important;
}
.nav-contain {
  display: none;
}
</style>

<script>
import Index from "./Index";
import swal from "sweetalert";
import Spinner from "@/components/Preloaders/Spinner";
import { mapMutations } from "vuex";
import VueFrame from "vue-frame";

export default {
  components: { Spinner, VueFrame },
  props: ["isdash"],
  data() {
    return {
      class_group: [],
      calc_input: {
        class_group: "",
        tutor_package: "",
        no_of_learners: "",
        duration: "",
        classes_per_week: "",
        hours_per_class: "",
        service_charge: "0",
        grand_total: "0"
      },
      states: [],
      state: "",
      locations: [],
      subjects: [],
      subject: "",
      sorted_location: [],
      location: "",
      price_list: [],
      tutor_package: ""
    };
  },
  computed: {
    generateGrandTotal() {
      var service_charge = 0;
      var tuition_fee =
        this.calc_input.classes_per_week *
        this.calc_input.duration *
        this.calc_input.tutor_package.amount;
      var additional_learner = 0;
      var additional_hour = 0;
      //check if there is additional price or learner
      if (this.calc_input.no_of_learners > 1) {
        additional_learner =
          (this.calc_input.no_of_learners - 1) *
          this.tutor_package.additional_learner;
      }
      if (this.calc_input.hours_per_class > 2) {
        additional_hour =
          (this.calc_input.hours_per_class - 2) *
          this.tutor_package.additional_hour;
      }
      this.calc_input.grand_total =
        service_charge + tuition_fee + additional_learner + additional_hour;
      // console.log(this.calc_input.service_charge,this.calc_input.no_of_learners)
      this.calc_input.grand_total = 0.7 * this.calc_input.grand_total;
      return this.calc_input.grand_total;
    }
  },
  methods: {
    afterTime(time) {
      if (time) {
        return this.times.filter(t => t.value > time);
      }
      return this.times;
    },
    beforeTime(time) {
      if (time) {
        return this.times.filter(t => t.value < time);
      }
      return this.times;
    },
    timeText(val) {
      const time = this.times.find(t => t.value === val);
      return time && time.title;
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    ucfirst: function(s) {
      return s[0].toUpperCase() + s.slice(1);
    },
    fetchSubjects() {
      //   console.log('ok')
      var crgp_id = this.calc_input.class_group.id;
      console.log(crgp_id);
      this.subjects = this.class_groups.filter(s => {
        return s.id === crgp_id;
      })[0].subjects;
    },
    assignTutorPackage(e) {
      var class_id = this.calc_input.class_group.id;
      var location_id = this.calc_input.location;
      var lesson_plan = this.calc_input.classes_per_week * 4;

      //use the data to run the filter
      var tutor_package = this.price_list.filter(r => {
        return (
          r.class_group_id === Number(class_id) &&
          r.tutor_listing_location_id === Number(location_id) &&
          r.lesson_plan === Number(lesson_plan)
        );
      });
      this.tutor_package = tutor_package[0];
      console.log(this.tutor_package);
    },
    fetchLocations() {
      this.sorted_location = this.locations.filter(s => {
        return s.state_id === this.state;
      });
      console.log(this.sorted_location);
    },
    findLandName() {
      //1 is for Mainland while 2 is for Island
      var location = this.location.land_type;
      console.log(this.location);
      if (location == "2") {
        //set the prop to island
        this.calc_input.location = "2";
      } else {
        this.calc_input.location = "1";
      }
      console.log(this.calc_input.location);
    },
    resetCalculator() {
      this.calc_input.class_group = "";
      this.calc_input.location = "";
      this.calc_input.tutor_package = "";
      this.calc_input.no_of_learners = "";
      this.calc_input.duration = "";
      this.calc_input.classes_per_week = "";
      this.calc_input.hours_per_class = "";
      this.calc_input.service_charge = "";
      this.calc_input.grand_total = "0";
    }
  },
  mounted: function() {
    //this.initializeDays();
    // this.getClassGroupsWithPackage();
  },
  filters: {
    service_charge_generator(value) {
      return value * 3000;
    },
    tuition_fee_generator(value) {
      //return this.calc_input.classes_per_week * this.calc_input.duration *this.calc_input.tutor_package;
    },
    numberFormat(value) {
      value.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/Profile/Calculator.vue